import { crudGetList } from 'react-admin';
import { useDispatch } from 'react-redux';
import { useQuery, useMutation } from 'react-query';
import {
  deleteMenu,
  deleteItem,
  fetchMenu,
  fetchInitialChildren,
  fetchChildrenById,
  fetchMenuItemById,
} from '~/api/menu';

interface DeleteProps {
  onSuccess: () => void;
  menuId?: string;
  itemId?: string;
}

export const useDeleteMenu = (props: DeleteProps) => {
  const { onSuccess } = props;
  const dispatch = useDispatch();

  return useMutation(deleteMenu, {
    onSuccess() {
      dispatch(crudGetList('menu', { page: 1, perPage: 10 }, { field: 'id', order: 'DESC' }, {}));
      onSuccess && onSuccess();
    },
  });
};

export const useDeleteItem = (props: DeleteProps) => {
  const { onSuccess } = props;
  return useMutation(deleteItem, {
    onSuccess() {
      onSuccess && onSuccess();
    },
  });
};

export const useFetchInitialChildren = (id: string) =>
  useQuery(['menu', id, 'items', '$'], () => fetchInitialChildren(id!), {
    enabled: !!id,
  });

export const useFetchChildrenById = () =>
  useMutation(({ menuId, itemId }: { menuId: string; itemId: string }) =>
    fetchChildrenById({ menuId, itemId })
  );

export const useAllMenu = () => useQuery(['menu'], fetchMenu);

export const useFetchMenuItemById = (onError: (error: any) => void) => {
  const mutation = useMutation(fetchMenuItemById, {
    onError,
  });
  return {
    mutateAsync: mutation.mutateAsync,
  };
};
